export default {
  Auth: {
    Cognito: {
      // REQUIRED - Amazon Cognito Identity Pool ID
      identityPoolId: 'us-east-1:fbb09891-723a-48db-80ac-facd1ca9ec4b',
      userPoolId: 'us-east-1_EvBbozIjd',
      userPoolClientId: 'kpd58387a2f9e4fe1d42sfd1q',
    },
  },
};
